import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { required, multiEmail, faxNumber, maxLength } from '@src/validation';
import axiosInstance from '@src/axios-instance';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';

const fieldValidator = {
  email: [required, multiEmail],
  email_cc: [multiEmail],
  email_bcc: [multiEmail],
  send_invoice: [],
  send_fax: [],
  fax_number: [faxNumber, value => maxLength(value, 255)],
  schedule_date: [required],
  schedule_time: [required]
};

const fieldFaxValidator = {
  email: [required, multiEmail],
  email_cc: [multiEmail],
  email_bcc: [multiEmail],
  send_invoice: [],
  send_fax: [],
  fax_number: [required, faxNumber, value => maxLength(value, 255)],
  schedule_date: [required],
  schedule_time: [required]
};

class EditScheduleModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    const email = props.entity.scheduled_email;
    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value:
          email[key] !== undefined && email[key] !== null ? email[key] : '',
        visited: false,
        error: false
      };
    });
    fields['schedule_date'].value = moment.unix(email.scheduled_date);
    this.state = { ...fields };
  }

  setSubmitType = name => {
    this.setState({
      submitType: name
    });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    const validator =
      this.state.send_fax.value === 0 ? fieldValidator : fieldFaxValidator;
    for (let i = 0; i < validator[name].length; i++) {
      const validationMsg = validator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;
    formData['schedule_date'].value = moment(formData['schedule_date'].value);

    const validator =
      this.state.send_fax.value === 0 ? fieldValidator : fieldFaxValidator;

    Object.keys(validator).forEach(key => {
      postData[key] =
        typeof formData[key].value === 'object'
          ? formData[key].value.format('YYYY-MM-DD')
          : formData[key].value;
      for (let i = 0; i < validator[key].length; i++) {
        const validationMsg = validator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });
    if (
      !moment(
        postData['schedule_date'] + postData['schedule_time'],
        'YYYY-MM-DDhh:mm'
      ).isAfter(moment()) &&
      this.state.submitType !== 'cancel'
    ) {
      formData.schedule_date.error =
        'Please pick a different time in the future.';
      isValid = false;
    }
    this.setState({ ...formData });

    postData['submit_type'] = this.state.submitType;
    if (isValid) {
      this.props.loading(true);
      axiosInstance()
        .post(
          `/evidence-of-insurances/update-schedule/${this.props.entity.scheduled_email.id}.json`,
          postData
        )
        .then(response => {
          this.props.getEntity();
          if (this.state.submitType === 'cancel') {
            this.props.onSuccess('EOI email schedule has been canceled.');
          } else {
            this.props.onSuccess('EOI email schedule has been updated.');
          }
          this.props.loading(false);
          this.props.toggle();
        })
        .catch(err => {
          alert(
            'Email authentication failed. Please contact your admin. Sender email and password information can be updated on Settings - Details view.'
          );
          this.props.loading(false);
        });
    }

    return false;
  };

  downloadPDF = (response, name) => {
    const byteCharacters = window.atob(response);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  downloadEmailAttachment = type => {
    this.props.loading(true);
    axiosInstance()
      .get(
        `/evidence-of-insurances/download-email-attachment/${this.props.entity.id}/${type}.json`
      )
      .then(response => {
        this.props.loading(false);
        this.downloadPDF(response.data.response, response.data.name);
      })
      .catch(err => {
        this.props.loading(false);
      });
  };

  render = () => {
    const attachments = [];
    const { entity } = this.props;
    let pdfName =
      entity.unit !== null
        ? `${entity.unit.address_no}_${entity.unit.street}_${entity.unit.unit_no}.pdf`.replace(
            ' ',
            '_'
          )
        : `${entity.association_name}.pdf`.replace(' ', '_');
    attachments.push(
      <span
        key={'eoi-pdf-attachment'}
        className={'pointer'}
        onClick={() => this.downloadEmailAttachment('eoi')}
      >
        {pdfName}
      </span>
    );

    const borrowName =
      entity.owner !== null
        ? entity.owner
            .split(' ')
            .slice(-1)
            .pop()
        : '';
    if (entity.qb_invoice_id !== null && !entity.qb_invoice_removed) {
      if (entity.bill_to_type === 'escrow-company') {
        pdfName = `invoice_${entity.qb_invoice_number}_${entity.escrow_company.name}_${entity.unit.association.name}_${borrowName}.pdf`
          .replace(/,/g, '')
          .replace(/ /g, '_');
      } else if (entity.bill_to_type === 'lender') {
        pdfName = `invoice_${entity.qb_invoice_number}_${entity.lender.name}_${entity.unit.association.name}_${borrowName}.pdf`
          .replace(/,/g, '')
          .replace(/ /g, '_');
      } else {
        pdfName = `invoice_${entity.qb_invoice_number}_${entity.unit.owner}_${entity.unit.association.name}_${borrowName}.pdf`
          .replace(/,/g, '')
          .replace(/ /g, '_');
      }

      attachments.push(', ');
      attachments.push(
        <span
          key={'qb-invoice-attachment'}
          className={'pointer'}
          onClick={() => this.downloadEmailAttachment('qb-invoice')}
        >
          {pdfName}
        </span>
      );
    }

    if (entity.include_cover_letter === 1) {
      if (entity.unit.association.cover_letter !== null) {
        pdfName = entity.unit.association.cover_letter
          .replace(/^.*[/]/, '')
          .replace(' ', '_');

        attachments.push(', ');
        attachments.push(
          <span
            className={'pointer'}
            onClick={() => this.downloadEmailAttachment('cover-letter')}
          >
            {pdfName}
          </span>
        );
      } else if (entity.tenant.cover_letter !== null) {
        pdfName = entity.tenant.cover_letter
          .replace(/^.*[/]/, '')
          .replace(' ', '_');
        attachments.push(', ');
        attachments.push(
          <span
            className={'pointer'}
            onClick={() => this.downloadEmailAttachment('cover-letter')}
          >
            pdfName
          </span>
        );
      }
    }
    if (
      entity.include_sample_quote === 1 &&
      entity.unit.association.sample_quote !== null
    ) {
      pdfName = entity.unit.association.sample_quote
        .replace(/^.*[/]/, '')
        .replace(' ', '_');
      attachments.push(', ');
      attachments.push(
        <span
          className={'pointer'}
          onClick={() => this.downloadEmailAttachment('sample-quote')}
        >
          {pdfName}
        </span>
      );
    }

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>{'Email'}</ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'Email Recipient (Separate emails with a comma)'}
                    type={'text'}
                    required={true}
                    {...this.state.email}
                    onChange={event => this.updateForm(event, 'email')}
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Cc'}
                    type={'text'}
                    {...this.state.email_cc}
                    onChange={event => this.updateForm(event, 'email_cc')}
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'Bcc'}
                    type={'text'}
                    {...this.state.email_bcc}
                    onChange={event => this.updateForm(event, 'email_bcc')}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Date *</label>
                    <div
                      className={
                        this.state.schedule_date.error ? 'is-invalid' : ''
                      }
                    >
                      <SingleDatePicker
                        date={this.state.schedule_date.value} // momentPropTypes.momentObj or null
                        onDateChange={issueDate =>
                          this.updateForm(issueDate, 'schedule_date')
                        } // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        block={true}
                        isOutsideRange={day => {
                          return (
                            !day.isAfter(moment()) &&
                            !day.isSame(moment(), 'day')
                          );
                        }}
                        onFocusChange={({ focused }) =>
                          this.setState({ focused })
                        } // PropTypes.func.isRequired
                        id="schedule_date" // PropTypes.string.isRequired,
                      />
                    </div>
                    {this.state.schedule_date.error && (
                      <span className={'error'}>
                        {this.state.schedule_date.error}
                      </span>
                    )}
                  </div>
                </Col>
                <Col>
                  <LabelInput
                    name={'Time'}
                    type={'time'}
                    required={true}
                    {...this.state.schedule_time}
                    onChange={event => this.updateForm(event, 'schedule_time')}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className={'pt-2'}>
                  <span>
                    <strong>Attachment: </strong>
                    <span className={CSS.attachments}>{attachments}</span>
                  </span>
                </Col>
                <Col xs={12} className={'pt-2'}>
                  <FormGroup check className={'pb-1'}>
                    <Label check>
                      <Input
                        type="checkbox"
                        defaultChecked={this.state.send_invoice.value === 1}
                        disabled={
                          this.props.entity.qb_invoice_id === null ||
                          this.props.entity.qb_invoice_removed
                        }
                        onChange={event =>
                          this.updateForm(
                            event.target.checked ? 1 : 0,
                            'send_invoice'
                          )
                        }
                      />{' '}
                      Email invoice from QuickBooks Online at the same time.
                    </Label>
                  </FormGroup>
                </Col>
                <Col xs={12} className={'pt-2'}>
                  <FormGroup check className={'pb-1'}>
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={this.state.send_fax.value === 1}
                        onChange={event =>
                          this.updateForm(
                            event.target.checked ? 1 : 0,
                            'send_fax'
                          )
                        }
                      />{' '}
                      Fax Evidence of Insurance document at the same time.
                    </Label>
                  </FormGroup>
                  {this.state.send_fax.value === 1 && (
                    <div className={'pl-4'}>
                      <LabelInput
                        name={'Fax (Separate fax numbers with a comma)'}
                        type={'text'}
                        {...this.state.fax_number}
                        onChange={event => this.updateForm(event, 'fax_number')}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4 justify-content-end'}>
              <Button
                color="light"
                className={'btn px-3'}
                type={'submit'}
                onClick={() => this.setSubmitType('cancel')}
              >
                Cancel Scheduled Email
              </Button>
              <Button
                color="primary"
                className={'btn px-3'}
                type={'submit'}
                onClick={() => this.setSubmitType('save')}
              >
                Save Changes
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default EditScheduleModal;
